<template>
    <div>
        <vggrid :random="Math.floor(Math.random() * 999999)" :list="list" flexname="" :cols="pexCols"
              :showfooter="false" :showPage="false" :resizable="true" >
            <template slot="btn">
                  <el-button type='primary' size="mini" class="vxe-btn" @click="toChangePoints">申请</el-button>
            </template>
      </vggrid>
    </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exApplyForModification',
    components: {vggrid},
    props:{
        pexchangetype:Number,
        activeName: {}
    },
    data () {
      return {
          pexCols:[
            {field: 'pexpertname', fieldtype: 'C', title: '申请人', calculExpr: '', addNewRowFlg: false},
            {field: 'pexchangetypename', fieldtype: 'C', title: '修改类型', calculExpr: '', addNewRowFlg: false},
            {field: 'pexchangetime', fieldtype: 'T', title: '申请时间', calculExpr: '',formatter: ['toDateString', ''], addNewRowFlg: false},
            {field: 'pexchangestatusname', fieldtype: 'C', title: '审核状态', calculExpr: '', addNewRowFlg: false},
            {field: 'username', fieldtype: 'C', title: '审核人', calculExpr: '', addNewRowFlg: false},
            {field: 'pexchangeretime', fieldtype: 'T', title: '审核时间', calculExpr: '',formatter: ['toDateString', ''], addNewRowFlg: false},
          ],
          list:[],
          btnLoading:false
      }
    },
    created () {
        this.getpexchangeList()
    },
    async activated(){
        await this.getpexchangeList()
    },
    watch:{
      activeName () {
        if(this.activeName === 'sqgf') {
            console.log(this.activeName)
            this.getpexchangeList()
        }
      }
    },
    methods: {
        toChangePoints(){
            this.$router.push({name: 'exApplyForModificationFrom',params: {pexchangetype:this.pexchangetype}})
            // projectid:this.$store.getters.expertLoginUser.pexpertprojectid,
            //                                 pexchangepexpertid:this.$store.getters.expertLoginUser.pexpertid
        },
        async getpexchangeList(){
            this.list = []
            let res = await request({
                method: 'get',
                url: 'expert/getpexchangeList',
                params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
            })

            this.list = res
        }
    }
  }
</script>

<style lang="scss" scoped>
</style>